/*
 * Partage d'un article — API native, repli sur la copie du lien.
 *
 * Aucun bouton de reseau social : chacun coute une requete vers un tiers et un
 * cookie pose avant tout consentement. `navigator.share` ouvre la feuille de
 * partage du systeme, celle que le lecteur connait deja, et qui contient ses
 * applications a lui.
 *
 * Sur ordinateur, ou l'API n'existe presque nulle part, on copie le lien. Le
 * bouton dit alors ce qui s'est passe : une action sans retour visible passe
 * pour une action ratee.
 */
class PartageArticle extends HTMLElement {
  connectedCallback() {
    this.bouton = this.querySelector('[data-partager]');
    if (!this.bouton) return;

    this.libelle = this.bouton.textContent.trim();
    this.bouton.addEventListener('click', () => this.partager());
  }

  async partager() {
    const donnees = {
      title: this.dataset.titre,
      url: this.dataset.url,
    };

    if (navigator.share) {
      try {
        await navigator.share(donnees);
        return;
      } catch (erreur) {
        /* L'utilisateur a ferme la feuille de partage : ce n'est pas une
         * erreur, et surtout pas une raison de copier le lien dans son dos. */
        if (erreur.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(this.dataset.url);
      this.confirmer();
    } catch (erreur) {
      /* Ni partage ni presse-papiers — navigateur ancien, ou page servie hors
       * HTTPS. Le lien reste dans la barre d'adresse : on ne fait rien plutot
       * que d'afficher un echec que le lecteur ne peut pas resoudre. */
    }
  }

  confirmer() {
    this.dataset.etat = 'copie';
    this.bouton.textContent = this.dataset.copie;

    clearTimeout(this.minuterie);
    this.minuterie = setTimeout(() => {
      delete this.dataset.etat;
      this.bouton.textContent = this.libelle;
    }, 2000);
  }
}

customElements.define('partage-article', PartageArticle);
